import React from "react";
import { FaPlus } from "react-icons/fa";

const EmptyState = ({
  title,
  icon: Icon,
  emptyMessage,
  addButtonText,
  onAdd = () => {},
}) => {
  return (
    <div className="text-center py-12">
      <div className="p-3 bg-mainBg rounded-full inline-flex mb-4">
        <Icon className="w-6 h-6 text-blue-600" />
      </div>
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{`No ${title} added yet`}</h3>
      <p className="text-gray-500 mb-6">{emptyMessage}</p>
      <button
        onClick={onAdd}
        className="inline-flex items-center px-4 py-2 text-sm font-medium text-blue-600 border border-blue-600 rounded-lg hover:bg-mainBg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
      >
        <FaPlus className="w-5 h-5 mr-2" />
        {addButtonText}
      </button>
    </div>
  );
};

export default EmptyState;
